const { ActionTypes } = require("../constants/action_types");

const initialState = 1;

export const cohortCountReducer = (state = initialState, { type, payload }) => {

    switch (type) {
        case ActionTypes.COHORT_DATA_COUNT:
            return state = payload; 
        default:
            return state;
    }
};